import { Link } from "react-router-dom";
import { siteName, footerLinks, siteSlogan } from "@/mocks/mangaData";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="grid w-9 h-9 place-items-center rounded-md bg-primary-500 text-background-50 text-lg">
                <i className="ri-heart-3-fill"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">{siteName}</span>
            </div>
            <p className="text-sm leading-7 text-foreground-700 max-w-md">
              以读者视角持续追踪《甜蜜惩罚漫画》的主线走向、分话节点与角色命运，结局线索持续更新。{siteSlogan}，不错过任何一个关键剧情。
            </p>
            <div className="mt-5 flex items-center gap-2">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 text-secondary-900 px-3 py-1 text-xs font-medium">
                <i className="ri-bookmark-line"></i>
                持续追踪中
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 text-accent-900 px-3 py-1 text-xs font-medium">
                <i className="ri-timer-line"></i>
                结局线索更新
              </span>
            </div>
          </div>

          {Object.entries(footerLinks).map(([group, links]) => (
            <div key={group}>
              <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">{group}</h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-700 hover:text-primary-700 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            © {new Date().getFullYear()} {siteName} · 读者向剧情追踪内容，非官方发布渠道
          </p>
          <p className="text-xs text-foreground-600">所有剧情分析均基于已公开分话整理，具体以官方更新为准</p>
        </div>
      </div>
    </footer>
  );
}